<template>
    <div>
        <!-- middle middle section -->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">
                        <div class="chat-btm-section-main add-user-main-section width-full float-l"> <!--middle section-->
                            <div class="chat-web-section chat-user-list-main float-l width-full"> <!--web view-->
                                <h2 class="chat-page-title float-l color-333333 heading-text-24 line-height-28 font-bold ucase pb_5">{{pageTitle}} 
                                    <span>(All times are in Sydney)</span>    
                                </h2>
                                <div class="user-listing-section-web customer-listing-section-web float-l width-full selection_schedule_container">
                                    <template v-if="!isUpdate">
                                        <v-select v-model="sectionId" @change="changeSectionId()" name="timezoneId" placeholder="Select Section"
                                            label="text"
                                            :options="sectionArr"
                                            id="sectionSelectWeb">
                                        </v-select>
                                    </template>
                                    <template v-else>
                                        <span class="form-control">{{sectionId.text}}</span>
                                    </template>
                                    <span class="help is-danger">{{ sectionError }}</span>

                                    <div class="panel-body row" style="padding-left: 15px; padding-top: 20px;">  
                                        <!-- Only code you need is this label -->
                                        <p style="padding-right: 15px;">Full day working?</p>
                                        <label class="switch">
                                            <input id="fullDayWorkSwitch" name="fullDayWorkSwitch" type="checkbox" @click="toggleFullDayWorkSwitch">
                                            <div class="slider round"></div>
                                        </label>
                                    </div>

                                    <template v-if="!fullDayWorkSwitch">
                                        <div class="user-listing-section-web customer-listing-section-web float-l width-full">
                                            <span class="content">Select Start Time</span>
                                            <!-- <timeselector v-model="startTime" returnFormat="HH" @formatedTime="formatedTime($event)"  :displayMinutes="false" :displaySeconds="false" :utc="false"></timeselector> -->
                                            <vue-timepicker @change="changeStartDate()" close-on-complete v-model="startTime" :minute-range="[0]" format="HH"></vue-timepicker>
                                            <span class="help is-danger">{{ startTimeError }}</span>
                                        </div>

                                        <div class="user-listing-section-web customer-listing-section-web float-l width-full selection_schedule_container-pull-right">
                                            <span class="content">Select End Time</span>
                                            <!-- <timeselector v-model="startTime" returnFormat="HH" @formatedTime="formatedTime($event)"  :displayMinutes="false" :displaySeconds="false" :utc="false"></timeselector> -->
                                            <vue-timepicker @change="changeEndDate()" close-on-complete v-model="endTime" :minute-range="[0]" format="HH"></vue-timepicker>
                                            <span class="help is-danger">{{ endTimeError }}</span>
                                        </div>
                                    </template>

                                    <div class="register-btn dayforce-id-btn float-l col-12">
                                        <button type="button" id="saveScheduleTime" v-on:click="saveTimeForSection()" class="btn btn-primary float-l mr_20">
                                            <span class="gradient"></span>Save
                                        </button>
                                        <button type="button" class="btn btn-primary float-l mr_20" v-on:click="onCancelClick()">
                                            <span class="gradient"></span>Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- web view -->

                            <div class="user-list-mobile float-l width-full mobile_selection_schedule_container"> <!--mobile view-->
                                <div class="add-user-form col-12 float-l mt_10">
                                    <div class="form-group float-l width-full pt_15 pl_15 pr_15 pb_0">
                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Section </p>
                                        <v-select v-model="sectionId" name="timezoneId" placeholder="Select Section"
                                            label="text"
                                            :options="sectionArr"
                                            id="sectionSelectMobile">
                                        </v-select>
                                        <span class="help is-danger">{{ sectionError }}</span>

                                        <div class="panel-body row" style="padding-left: 15px; padding-top: 20px;">  
                                            <!-- Only code you need is this label -->
                                            <p style="padding-right: 15px;">Full day working?</p>
                                            <label class="switch">
                                                <input id="fullDayWorkSwitch-mobile" name="fullDayWorkSwitch" type="checkbox" @click="toggleFullDayWorkSwitch">
                                                <div class="slider round"></div>
                                            </label>
                                        </div>

                                        <template v-if="!fullDayWorkSwitch">
                                            <div class="form-group float-l width-full pt_15 pb_0">
                                                <span class="content">Select Start Time</span>
                                                <!-- <timeselector v-model="startTime" returnFormat="HH" @formatedTime="formatedTime($event)"  :displayMinutes="false" :displaySeconds="false" :utc="false"></timeselector> -->
                                                <vue-timepicker @change="changeStartDate()" close-on-complete v-model="startTime" :minute-range="[0]" format="HH"></vue-timepicker>
                                                <span class="help is-danger">{{ startTimeError }}</span>
                                            </div>

                                            <div class="form-group float-l width-full pt_15 pb_0">
                                                <span class="content">Select End Time</span>
                                                <!-- <timeselector v-model="startTime" returnFormat="HH" @formatedTime="formatedTime($event)"  :displayMinutes="false" :displaySeconds="false" :utc="false"></timeselector> -->
                                                <vue-timepicker @change="changeEndDate()" close-on-complete v-model="endTime" :minute-range="[0]" format="HH"></vue-timepicker>
                                                <span class="help is-danger">{{ endTimeError }}</span>
                                            </div>
                                        </template>
                                        <div class="register-btn dayforce-id-btn float-l col-12">
                                            <button type="button" id="saveScheduleTimeMobile" v-on:click="saveTimeForSection()" class="btn btn-primary float-l mr_20">
                                                <span class="gradient"></span>Save
                                            </button>

                                            <button type="button" class="btn btn-primary float-l mr_20" v-on:click="onCancelClick()">
                                                <span class="gradient"></span>Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- mobile view -->
                        </div>
                        <!-- middle section -->
                    </div>
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <!-- middle middle section -->
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from '../event-bus';
    // Main JS (in UMD format)
    import VueTimepicker from 'vue2-timepicker'
    // CSS
    import 'vue2-timepicker/dist/VueTimepicker.css'
    import moment from 'moment';

    var contex;
    Vue.component("app-footer", Footer);
    export default {
        name: 'ScheduleSection',
        mixins: [commonMixins],
        components: {
            VueTimepicker
        },
        data () {
            return {
                isRequestComplete: false,
                sectionId: {

                },
                pageTitle : "Add Schedule Section",
                sectionArr: [],
                cantAccessPage: true,
                startTime : '00',
                endTime : '00',
                startTimeError : '',
                endTimeError : '',
                sectionError : '',
                scheduleTimeId : 0,
                previousSectionId : 0,
                isUpdate: false,
                fullDayWorkSwitch: false
            }
        },
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
            var self = this;
            $("#sectionSelectWeb").removeClass("js-example-disabled");
            $("#sectionSelectMobile").removeClass("js-example-disabled");
            // EventBus.$emit("headerMobileView", 'Customer List');
            EventBus.$emit("headerMobileView", 'Add Schedule Section (All times are in Sydney)');
            self.getPermissions();
            self.loadSection();

            self.mobileResizeViewCustomerListPage();
            window.onresize = function() {
                self.mobileResizeViewCustomerListPage();
            }

            var path = window.location.pathname;
            var segments = path.split("/");
            self.isUpdate = false;
            if (segments[2] == 'update') {
                if (segments[3]) {
                    $("#sectionSelectWeb").addClass("js-example-disabled");
                    $("#sectionSelectMobile").addClass("js-example-disabled");
                    self.pageTitle = 'Edit Schedule Section';
                    self.scheduleTimeId = segments[3];
                    self.loadSectionScheduleTime();
                    $("#saveScheduleTime").html('Update');
                    $("#saveScheduleTimeMobile").html('Update');
                    self.isUpdate = true;
                }
            }
        },
        watch : {

        },
        methods: {
            toggleFullDayWorkSwitch() {
                var self = this;
                self.fullDayWorkSwitch = !self.fullDayWorkSwitch;
                if(!self.isUpdate) {
                    self.startTime = "";
                    self.endTime = "";
                    self.startTimeError = "";
                    self.endTimeError = "";
                }
                if(!self.fullDayWorkSwitch) {
                    if(!self.isUpdate) {
                        self.startTime = "00";
                        self.endTime = "00";
                    }
                }
                // self.$emit('setCheckboxVal', self.fullDayWorkSwitch);
            },
            backToList: function() {
                var self = this;
                self.$router.push("/sectionscheduletime/list");
            },
            onCancelClick : function () {
                let self = this;
                self.backToList();
            },
            loadSectionScheduleTime : function () {
                let self = this;
                var fields = {
                    scheduleTimeId : self.scheduleTimeId,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("get-schedule-section-time", fields, config)
                    .then(function (data) {
                        // console.log(data.data.content.section_name);
                        if (data.data.code == 200 && data.data.status == 'success') {
                            self.sectionId = {
                                text : data.data.content.section_name,
                                value : data.data.content.section_id,
                            };
                            self.fullDayWorkSwitch = (data.data.content.is_full_day_working) ? true : false;
                            $("#fullDayWorkSwitch").prop("checked", false);
                            $("#fullDayWorkSwitch-mobile").prop("checked", false);
                            if(self.fullDayWorkSwitch) {
                                $("#fullDayWorkSwitch").prop("checked", true);
                                $("#fullDayWorkSwitch-mobile").prop("checked", true);
                            }

                            self.startTime = data.data.content.start_time;
                            self.endTime = data.data.content.end_time;
                            self.previousSectionId = data.data.content.section_id;
                        }
                    })
                    .catch(function (error) {
                        // con
                        self.catchHandler(error, function () {
                        });
                    })
            },
            validateForm : function () {
                let self = this;
                var checked = true;
                self.sectionError = "";
                self.startTimeError = "";
                self.endTimeError = "";

                if(!self.fullDayWorkSwitch) {
                    if (self.startTime == "" || self.startTime == null) {
                        self.startTimeError = "Please select start time";
                        if (checked) {
                            checked = false;
                        }
                    }

                    if (self.endTime == "" || self.endTime == null) {
                        self.endTimeError = "Please select end time";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.endTime < self.startTime) {
                        self.endTimeError = "End time should not less than start time";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.startTime == self.endTime) {
                        self.endTimeError = "Start time and end time should not be same";
                        if (checked) {
                            checked = false;
                        }
                    }
                }

                if (self.sectionId.value == 0 || self.sectionId.value == "" || self.sectionId.value == null || self.sectionId.value == "undefined") {
                    self.sectionError = "Please select section";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            saveTimeForSection : function () {
                let self = this;
                if (self.validateForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    if (segments[2] == 'update') {
                        if (segments[3]) {
                            if (self.previousSectionId == self.sectionId.value) {
                                var fields = {
                                    previousSectionId : "same",
                                    id : segments[3],
                                    sectionId : self.sectionId.value,
                                    startTime : !self.fullDayWorkSwitch ? moment(new Date()).format('YYYY-MM-DD') + " " + self.startTime + ":00:00" : '',
                                    endTime : !self.fullDayWorkSwitch ? moment(new Date()).format('YYYY-MM-DD') + " " + self.endTime + ":00:00" : '',
                                    fullDayWork: self.fullDayWorkSwitch ? 1 : 0,
                                    currentDate : moment(new Date()).format('YYYY-MM-DD'),
                                };
                            } else {
                                var fields = {
                                    previousSectionId : "not same",
                                    id : segments[3],
                                    sectionId : self.sectionId.value,
                                    startTime : !self.fullDayWorkSwitch ? moment(new Date()).format('YYYY-MM-DD') + " " + self.startTime + ":00:00" : '',
                                    endTime : !self.fullDayWorkSwitch ? moment(new Date()).format('YYYY-MM-DD') + " " + self.endTime + ":00:00" : '',
                                    fullDayWork: self.fullDayWorkSwitch ? 1 : 0,
                                    currentDate : moment(new Date()).format('YYYY-MM-DD'),
                                };
                            }
                        }
                    } else {
                        var fields = {
                            sectionId : self.sectionId.value,
                            startTime : !self.fullDayWorkSwitch ? moment(new Date()).format('YYYY-MM-DD') + " " + self.startTime + ":00:00" : '',
                            endTime : !self.fullDayWorkSwitch ? moment(new Date()).format('YYYY-MM-DD') + " " + self.endTime + ":00:00" : '',
                            fullDayWork: self.fullDayWorkSwitch ? 1 : 0,
                            currentDate : moment(new Date()).format('YYYY-MM-DD'),
                        };
                    }
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    // alert(localStorage.getItem("tkn"));return false;
                    self.firstLoad = 1;
                    self.showLoader();
                    // HTTP.post("list-customer", fields, config)
                    HTTP.post("add-schedle-time-for-section", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                               self.backToList()
                            }
                            self.hideLoader();
                        })
                        .catch(function (error) {
                            self.hideLoader();
                            self.catchHandler(error, function () {});
                        });
                }

            },
            changeSectionId : function () {
              let self = this;
              self.sectionError = "";
            },
            changeStartDate : function () {
                let self = this;
                self.startTimeError = "";
            },
            changeEndDate : function () {
                let self = this;
                self.endTimeError = "";
            },
            mobileResizeViewCustomerListPage: function() {
                var self = this;
                if (window.innerWidth < 766) {
                    self.mobileView = true;
                } else {
                    self.mobileView = false;
                }
            },
            loadSection: function() {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.get("get-sections", config)
                    .then(function (data) {
                        if (data.data.code == 200 && data.data.status == 'success') {
                            self.sectionArr = data.data.content;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error, function () {});
                    })
            },
        }
    }
</script>

<style>
    /* .js-example-disabled {
        pointer-events: none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    } */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }
    .switch input {
        display: none;
    }
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }
    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }
    input:checked + .slider {
        background-color: #101010;
    }
    input:focus + .slider {
        box-shadow: 0 0 1px #101010;
    }
    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/SectionScheduler/AddUpdateSectionScheduleTime.vue